import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'arrow-right-icon',
  templateUrl: './arrow-right-icon.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class ArrowRightIconComponent {}
